// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"8fafffa8","76":"edf9b938","99":"8b629a5f","264":"6e2e921d","425":"be1f19cd","439":"b3387a60","466":"4182344d","476":"7c50bbf1","518":"83718485","540":"b8e73a2b"}[chunkId] + ".chunk.js";
};